import { useMemo } from 'react';

import { useCart } from 'hooks/use-cart';
import { useUIContext } from 'state/ui';

export const useCartButtonText = () => {
  const { formatCurrencyForLocale } = useUIContext();
  const { calculateCartTotal } = useCart();

  const cartButtonText = useMemo(() => formatCurrencyForLocale(calculateCartTotal()), [
    calculateCartTotal,
    formatCurrencyForLocale,
  ]);

  return { cartButtonText };
};
